module.exports = __webpack_public_path__ + "img/WF_17_sm.5e372125.jpg";